export default {
  text: '#232323',
  primary: '#ada89d',
  secondary: '#ede8e0',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
